"use client";

import { motion } from "framer-motion";
import Header from "@/components/header";
import Footer from "@/components/footer";
import { PageTitle } from "@/components/ui/page-header";
import { ButtonPrimary } from "@/components/ui/button-primary";
import { containerVariants, itemVariants } from "@/lib/animation-variants";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export default function MediaKitPage() {
  const handleDownload = () => {
    // Direct download link to the zip file in public folder
    const link = document.createElement("a");
    link.href = "/mediakit.zip";
    link.download = "AV-Gothia-150-Stiftungsfest-Mediakit.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex min-h-screen flex-col bg-gothia-green">
      <Header />
      <main className="flex-1 px-4 pb-20 pt-8 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="mx-auto max-w-4xl">
          <PageTitle
            title="Mediakit"
            subtitle="Lade dir alle Materialien für Presse, Social Media und Marketing herunter"
            className="mb-12"
          />

          <motion.div variants={itemVariants} className="mb-8">
            <Card variant="default">
              <CardHeader
                title="Komplettes Mediakit"
                titleCaption="Alle Assets in einem ZIP-Archiv"
                className="mb-4"
              />
              <CardContent>
                <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
                  <p className="text-body-sm text-gray-700">
                    Lade dir alle Materialien für Presse, Social Media und Marketing in einem ZIP-Archiv herunter.
                  </p>
                  <ButtonPrimary
                    onClick={handleDownload}
                    className="w-full sm:w-auto">
                    <svg
                      className="mr-2 h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    ZIP herunterladen
                  </ButtonPrimary>
                </div>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div variants={itemVariants} className="mt-8">
            <Card variant="default">
              <CardHeader title="Verwendung" className="mb-4" />
              <CardContent>
                <div className="space-y-4">
                  <p className="text-body-sm text-gray-700">
                    Die Materialien in diesem Mediakit dürfen für Presseberichte,
                    Social-Media-Posts und Marketing-Materialien zum 150. Stiftungsfest
                    verwendet werden. Die Grafiken dürfen nicht bearbeitet oder
                    verändert werden.
                  </p>
                  <p className="text-body-sm text-gray-700">
                    Bei Fragen wende dich gerne an{" "}
                    <a
                      href="mailto:organisation@gothia150.de"
                      className="font-semibold text-gothia-green transition-colors hover:text-gothia-gold">
                      organisation@gothia150.de
                    </a>
                    .
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}

